// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"353":"contact","594":"about","652":"service","946":"news"}[chunkId] + "." + {"353":"a7e73d78","594":"40486d35","652":"1fc56696","946":"7e30e70c"}[chunkId] + ".css";
};